export default __webpack_public_path__ + "static/media/beneficiarios.b34f56c2.png";